import type { SpartacuxCoreState } from '../core.state';

export const isMobileAppUserAgentSelector = (state: SpartacuxCoreState) =>
  state.core.client.isMobileAppUserAgent;

export const isDatadogUserAgent = (state: SpartacuxCoreState) =>
  state.core.client.isDatadogUserAgent;
